import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: "/",

    component: () => import("@/views/Home"),

    children: [{
        path: "/",
        redirect: "/index"
      },
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index.vue")
      },
      {
        path: "/mobile",
        name: "mobile",
        component: () => import("@/views/mobile.vue")
      },
      {
        path: "/dmp",
        name: "dmp",
        component: () => import("@/views/dmp.vue")
      },
      {
        path: "/tool",
        name: "tool",
        component: () => import("@/views/tool.vue")
      },
      {
        path: "/api",
        name: "api",
        component: () => import("@/views/api.vue")
      },
      {
        path: "/weibo",
        name: "weibo",
        component: () => import("@/views/weibo.vue")
      },
      {
        path: "/zhihu",
        name: "zhihu",
        component: () => import("@/views/zhihu.vue")
      },
      {
        path: "/bilibili",
        name: "bilibili",
        component: () => import("@/views/bilibili.vue")
      },
      {
        path: "/cooperationCase",
        name: "cooperationCase",
        component: () => import("@/views/cooperationCase.vue")
      },
      {
        path: "/cooperDetail",
        name: "cooperDetail",
        component: () => import("@/views/cooperDetail.vue")
      },
      {
        path: "/refershs",
        name: "refershs",
        component: () => import("@/views/refershs.vue")
      },
      {
        path: "/article",
        name: "article",
        component: () => import("@/views/article.vue")
      },
      {
        path: "/articlePage",
        name: "articlePage",
        component: () => import("@/views/articlePage.vue")
      },
      {
        path: "/aboutUs",
        name: "aboutUs",
        component: () => import("@/views/aboutUs.vue")
      },
      {
        path: "/operation",
        name: "operation",
        component: () => import("@/views/operation.vue")
      }
    ]
  }]
});